/* eslint-disable no-nested-ternary */
import { Grid } from '@material-ui/core';
import {
  Block,
  Business,
  DateRangeRounded,
  Description as DescriptionIcon,
  Euro as EuroIcon,
  EventAvailable,
  HomeRounded,
  Language as LanguageIcon,
  Loop as LoopIcon,
  MenuBookRounded,
  SchoolRounded as SchoolIcon,
} from '@material-ui/icons';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import RoomIcon from '@material-ui/icons/Room';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  getInfosAccountRestricted,
  connectASchoolPartner,
  checkIfPostuleTraining,
  checkIfSavedTraining,
  getInfosDashboard,
  postuleTraining,
  savedTraining,
  unSavedTraining,
} from '@webapps/business';
import {
  Button,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import DottedWire from 'components/Icons/DottedWire';
import GradeIcon from 'components/Icons/GradeIcon';
import HourglassHalf from 'components/Icons/HourglassHalf';
import ListChecked from 'components/Icons/ListChecked';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

const Informations = ({
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  accountInfos,
  info = {},
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser, profile } = useAuth();

  const { addToast } = useToast();

  const {
    isLoading: isLoadingSavedTraining,
    isSuccess: isSuccessSave,
    mutateAsync: mutateSavedTraining,
  } = useMutation(savedTraining);

  const {
    isLoading: isLoadingPostuleTraining,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleTraining,
  } = useMutation(postuleTraining);

  const {
    isLoading: isLoadingUnSavedTraining,
    isSuccess: isSuccessUnSave,
    mutateAsync: mutateUnSavedTraining,
  } = useMutation(unSavedTraining);

  const { data: checkSave = {}, refetch } = useQuery(checkIfSavedTraining, {
    key: ['checkSavedTraining'] + idUser + info?.id,
    variables: { idApplicant: idUser, idTraining: info?.id },
  });

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleTraining,
    {
      key: ['checkPostuleTraining'] + idUser + info?.id,
      variables: { idApplicant: idUser, idTraining: info?.id },
    }
  );

  useEffect(() => {
    if (isSuccessSave) {
      addToast({
        status: 'success',
        message: 'Formation sauvegardée',
      });
    }

    refetch();
  }, [isSuccessSave]);

  const { data: infosSchool = {}, refetch: refetchInfosSchool } = useQuery(
    getInfosDashboard,
    {
      key: 'infoDashboardSchool' + info.school?.id,
      variables: { id: info.school?.id },
    }
  );

  const { data: infoSchoolAccount = {} } = useQuery(getInfosAccountRestricted, {
    key: 'infoSchoolAccount' + info?.school?.id,
    variables: { id: info?.school?.id },
    enabled: !!info?.school?.id,
  });

  useEffect(() => {
    if (isSuccessPostule) {
      addToast({
        status: 'success',
        message: 'Vous avez postulé à la formation',
      });
    }
    refetchPostule();
  }, [isSuccessPostule]);

  const handleOpenVitrine = (id) => {
    push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id }, from: 'map' });
  };

  useEffect(() => {
    if (isSuccessUnSave) {
      addToast({
        status: 'success',
        message: 'Formation retirée des sauvegardes',
      });
    }
    refetch();
  }, [isSuccessUnSave]);

  useEffect(() => {
    refetchInfosSchool();
  }, [info.school?.id]);

  const saveTraining = async () => {
    await mutateSavedTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: info?.id,
        },
      },
    });
  };

  const { push } = useRouter();

  const postuTraining = async () => {
    await mutatePostuleTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: info?.id,
        },
      },
    });
  };

  const unSaveTraining = async () => {
    await mutateUnSavedTraining({
      idApplicant: idUser,
      idTraining: info?.id,
    });
  };

  const date = new Date();


  const {
    error: isErrorConnect,
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectASchoolPartner);

  const reqPartner = async () => {
    await mutateConnect({
      data: {
        businessId: idUser,
        schoolId: info?.school?.id,
      },
    });
  };

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleRefetch();
    }
    if (isErrorConnect) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la demande',
      });
    }
  }, [isSuccessConnect, isErrorConnect]);

  console.log("info?.description ", info?.description);

  return (
    <div className={classes.overflowContainer}>
      <div className={classes.container}>
        <div className={cx(global.title, classes.title)}>
          <p style={{ margin: 0 }}>Informations pratiques</p>
        </div>
        <div>
          <Grid container className={classes.infoPratique}>
            <Grid
              item
              xs={12}
              md={6}
              lg={5}
              xl={4}
              className={css({ marginRight: '16px' })}
            >
              <div className={classes.info}>
                <MenuBookRounded className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <span>{info?.domain?.label}</span>
                </div>
              </div>

              <div className={classes.info}>
                <SchoolIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="levelDiplome" /> :{' '}
                  <span>Domaine d'étude : {info?.degree?.label}</span>
                </div>
              </div>

              <div className={classes.info}>
                <DescriptionIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Type de formation : <span>{info?.trainingType?.label}</span>
                </div>
              </div>

              <div className={classes.info}>
                <HourglassHalf className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="dureeFormation" /> :{' '}
                  <span>{info?.duration} mois</span>
                </div>
              </div>

              {/* En fait quand c'est vide c'est '  /  ', on enleve les espaces et on verifie si la longueur est superieur a 2 */}
              {info?.rythmAlternance?.trim().length > 2 && (
                <div className={classes.info}>
                  <LoopIcon className={cx(global.infoIcon, classes.itemIcon)} />
                  <div>
                    <FormattedMessage id="cycleAlternance" /> :{' '}
                    <span>{info?.rythmAlternance}</span>
                  </div>
                </div>
              )}

              <div className={classes.info}>
                <GradeIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="reconaissanceDiplome" /> :{' '}
                  <span>
                    {info?.certifyingAuthority?.label === 'Etat'
                      ? 'Reconnu par l’état'
                      : 'Non reconnu par l’état'}
                  </span>
                </div>
              </div>

              <div className={classes.info}>
                <ListChecked className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="conditionAdmission" /> :{' '}
                  <span>{info?.entryRequierement?.label}</span>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={5}
              xl={4}
              className={classes.paddingTopMobile}
            >
              <div className={classes.info}>
                <HomeRounded className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Présence : <span>{info?.studyPlan?.label}</span>
                </div>
              </div>

              <div className={classes.info}>
                <DateRangeRounded className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Dépot de candidature :{' '}
                  <FormattedDate
                    day="numeric"
                    month="numeric"
                    value={info?.applicationStartDate}
                    year="numeric"
                  />{' '}
                  au{' '}
                  <FormattedDate
                    day="numeric"
                    month="numeric"
                    value={info?.applicationClosingDate}
                    year="numeric"
                  />
                </div>
              </div>

              <div className={classes.info}>
                <EventAvailable className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  Prochaine rentrée :{' '}
                  <span>
                    <FormattedDate
                      day="numeric"
                      month="long"
                      value={info?.openingDate}
                      year="numeric"
                    />
                  </span>
                </div>
              </div>

              <div className={classes.info}>
                <LanguageIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="langEnseignement" /> :{' '}
                  <span>
                    {info?.workedLangage?.map(({ label }, index) =>
                      index !== info.workedLangage.length - 1
                        ? `${label}, `
                        : label
                    )}
                  </span>
                </div>
              </div>

              <div className={classes.info}>
                <EuroIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="fraisInscription" /> :{' '}
                  <span>{info?.programCost} €</span>
                </div>
              </div>

              <div className={classes.info}>
                <EuroIcon className={cx(global.infoIcon, classes.itemIcon)} />
                <div>
                  <FormattedMessage id="fraisScolarite" /> :{' '}
                  <span>{info?.registrationFees} €</span>
                </div>
              </div>
            </Grid>
          </Grid>

          <div className={classes.textContainer}>
            <div className={cx(global.title, classes.title)}>
              <p style={{ margin: 0 }}>Description</p>
            </div>
            <div className={classes.textarea}>
              {info?.description ? (
                <div className={classes.modifyLink}>
                  {parse(info?.description)}
                </div>
              ) : (
                <div>Pas de description de la formation</div>
              )}
            </div>
          </div>
          {infosSchool.profile?.presentation && (
            <div className={classes.textContainer}>
              <div className={cx(global.title, classes.title)}>
                <p style={{ margin: 0 }}>Qui sommes-nous ?</p>
              </div>
              <div className={classes.modifyLink}>
                {parse(infosSchool.profile.presentation)}
              </div>
            </div>
          )}
          {profile === 'INDIVIDUAL' && (
            <div className={classes.btnsContainer2}>
              <div className={classes.btnaddfavoris}></div>
            </div>
          )}
          <div
            className={css({
              display: 'flex',
              columnGap: '10px',
              '@media screen and (min-width: 1023px)': {
                display: 'none',
              },
              '@media screen and (max-width: 1023px)': {
                flexDirection: 'column',
                columnGap: 0,
                rowGap: '10px',
              },
            })}
          >
            {profile === 'BUSINESS' && (
              <>
                {partnersAccepted?.find(({ id }) => id === info?.school?.id) && (
                  <Button
                    startIcon={<Partenaire />}
                    className={css({
                      width: '100%',
                      height: '43px',
                      '&:disabled': {
                        color: '#A6A6A6',
                        backgroundColor: '#E0E0E0',
                      },
                    })}
                    color="primary"
                    //   onClick={logiquepartenariat}
                    variant="contained"
                    disabled
                  >
                    <FormattedMessage id="business.dashboard.dashboardBtns.partnerActive" />
                  </Button>
                )}
                {accountInfos?.subscription &&
                  accountInfos?.subscription.toLowerCase() == 'premium' &&
                  infoSchoolAccount?.subscription &&
                  infoSchoolAccount?.subscription.toLowerCase() == 'premium' &&
                  !partnersAccepted?.find(({ id }) => id === info?.school?.id) &&
                  !partnersRequested?.find(({ id }) => id === info?.school?.id) &&
                  !partnersReceived?.find(({ id }) => id === info?.school?.id) && (
                    <Button
                      className={css({
                        height: '43px',
                        '&:disabled': {
                          color: '#A6A6A6',
                          backgroundColor: '#E0E0E0',
                        },
                      })}
                      startIcon={<Partenaire />}
                      color="primary"
                      onClick={reqPartner}
                      variant="contained"
                    >
                      <FormattedMessage id="business.dashboard.dashboardBtns.partnerbtn" />
                    </Button>
                  )}
                {(partnersRequested?.find(({ id }) => id === info?.school?.id) ||
                  partnersReceived?.find(({ id }) => id === info?.school?.id)) && (
                    <Button
                      className={css({
                        height: '43px',
                        '&:disabled': {
                          color: '#A6A6A6',
                          backgroundColor: '#E0E0E0',
                        },
                      })}
                      startIcon={<Partenaire />}
                      color="primary"
                      //   onClick={logiquepartenariat}
                      variant="contained"
                      disabled
                    >
                      <FormattedMessage id="business.dashboard.dashboardBtns.partnerPending" />
                    </Button>
                  )}
              </>
            )}
            {profile === 'INDIVIDUAL' && (
              <>
                {checkPostule ? (
                  <Button
                    disabled
                    variant="outlined"
                  >
                    Déjà postulé
                  </Button>
                ) : new Date(info?.applicationStartDate?.split('T')[0]) <=
                  date &&
                  new Date(info?.applicationClosingDate?.split('T')[0]) >=
                  date ? (
                  <Button
                    color="primary"
                    disabled={isLoadingPostuleTraining}
                    onClick={postuTraining}
                    variant="contained"
                  >
                    Postuler
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    style={{
                      backgroundColor: '#E0E0E0',
                      color: '#A6A6A6',
                    }}
                    disabled
                    startIcon={<Block />}
                    variant="contained"
                  >
                    Formation fermée
                  </Button>
                )}
                {checkPostule &&
                  (checkSave ? (
                    <Button
                      disabled={isLoadingUnSavedTraining}
                      onClick={unSaveTraining}
                      startIcon={<FavoriteIcon color="primary" />}
                      variant="outlined"
                    >
                      <FormattedMessage id="AddedToFavorite" />
                    </Button>
                  ) : (
                    <Button
                      disabled={isLoadingSavedTraining}
                      onClick={saveTraining}
                      startIcon={<FavoriteBorderIcon />}
                      variant="outlined"
                    >
                      <FormattedMessage id="AddToFavorite" />
                    </Button>
                  ))
                }
              </>
            )}
            {profile === 'SCHOOL' ? null : (
              <Button
                className={cx(
                  css({
                    height: 'unset',
                    '&:hover': {
                      backgroundColor: '#F3F7FF',
                      color: '#5A6DA1',
                    },
                  })
                )}
                onClick={() => handleOpenVitrine(info?.school?.id)}
                variant="outlined"
              >
                <VisibilityIcon style={{ marginRight: 5 }} /> Visualiser la
                vitrine
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  overflowContainer: {
    overflowX: 'auto',
  },
  container: {
    padding: '30px',
    columnGap: 30,
    borderRadius: 10,
  },
  btnsContainer2: {
    display: 'flex',
    '@media only screen and (max-width:1023px)': {
      flexDirection: 'column',
      width: '100%',
    },
  },
  btnaddfavoris: {
    marginLeft: 16,
    '@media only screen and (max-width:1023px)': {
      marginTop: '10px',
      width: '100%',
      marginLeft: 0,
    },
  },
  title: {
    marginBottom: '10px',
    '& p': {
      borderLeft: '3px solid #0060F9',
      paddingLeft: spacing(1),
    },
  },
  textContainer: {
    marginTop: '20px',
    '& > *': {
      textAlign: 'justify',
    },
  },
  info: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    color: '#152652',
  },
  infoPratique: {
    marginBottom: '30px',
  },
  modifyLink: {
    color: '#152652',
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
    '& p': {
      marginTop: 0,
      marginBottom: 0,
    },
    a: {
      textDecoration: 'none',
      color: '#0183FF',
    },
  },
  itemIcon: {
    color: '#0060F9',
  },
});

export default Informations;
